/**
 * Created by ronmarsiano on 05/12/2017.
 *
 * always on configuration directive
 */
mainApp.directive('alwaysOnConfig', function() {
    return {
        templateUrl: '/public/directives/alwaysOnConfig.html',
        scope: {
            // always on properties is mandatory for saving
            alwaysOnProperties : '=',
            model: '='
        },
        controller:  ['$scope', '$timeout', '$state',"IconsService","GeneralUtilsService", function($scope, $timeout, $state,IconsService,GeneralUtilsService) {

            // constant the number of seconds till code changes
            var OVERRIDE_TIME_PERIOD = 60 * 15;
            $scope.code = {};
            $scope.errorMessage = {showError: false};

            let updateExpirationMessageTimeout;
            let getCurrentCodeTimeout;
            let updateTimerTimeout;

            // timer properties responsible for preventing multiple updates of the timer
            var timerProperties = {
                stop: false,
                stopCallback : function () {
                    timerProperties.stop = false;
                    init();
                }};


            /**
             * callback should be triggered when error occurred while loading
             * the img of the qr code
             */
            function onImgError () {
                $scope.imgError = true;
                $scope.errorMessage.message = "could not load QR code";
                $scope.errorMessage.showError = true;
            };


            /**
             * update the expiration message time according to the current code and remaning time
             */
            var updateExpirationMessage = function () {
                var qrImageEl = document.getElementById('qrImage');
                if ($scope.alwaysOnProperties && qrImageEl) {
                    if ($scope.timer && $scope.timer.currentTimeOut) {
                        if(!$scope.code.value){
                            getCurrentCodeTimeout = $timeout(getCurrentCode,1000);
                            $timeout(function () {
                                qrImageEl.src = '/getAlwaysOnQrCode?accountId=' + $state.params.accountId+'&timeTag='+(new Date).getTime();
                            },1000);
                            updateExpirationMessageTimeout = $timeout(updateExpirationMessage,1000);
                        }
                    }
                }
            };


            /**
             * return the current amount of minutes until expiration
             * @returns {Number}
             */
            $scope.getCurrentExpirationMinutes = function () {
                return parseInt((($scope.timer.currentTimeOut - $scope.timer.currentTimeOut % 60) / 60));
            };


            /**
             * return the current amound ot seconds until the expiration
             * @returns {Number}
             */
            $scope.getCurrentExpirationSeconds = function () {
                return parseInt($scope.timer.currentTimeOut % 60);
            };


            /**
             * start the timer which counts till the qr and the codes
             * aught to be changed
             */
            var startTimer = function () {
                var milliseconds = (new Date).getTime();
                $scope.timer = {};
                $scope.timer.tasks = [];
                $scope.timer.currentTimeOut = OVERRIDE_TIME_PERIOD - (parseInt((milliseconds/1000)) % (OVERRIDE_TIME_PERIOD));
                updateTimer();
            };


            /**
             * get the current code found at the server whenever we get
             * a new code we update the code
             */
            var getCurrentCode = function (callback) {
                store.fetch({
                    path: "getCurrentBypassCode?accountId="+$state.params.accountId,
                    method: "GET",
                    success: function(data) {
                        if(data != null) {
                            if(data.code){
                                changeCode(data.code)
                                $scope.code.timestamp = (new Date).getTime();
                                if(callback){
                                    callback();
                                }
                                if(!$scope.code.timestamp || !$scope.code.value ||
                                    ($scope.code.timestamp + (OVERRIDE_TIME_PERIOD*1000))<= (new Date).getTime()){
                                    // each minute recheck the code
                                    $timeout(getCurrentCode,60000);
                                }
                            }
                        }
                    }
                });
            };


            /**
             * update the timer counter (which is in seconds ) if timer got to 0
             * we reinitialize it, and schedule a task (update timer) to 1 seconds
             * each time we update the expiration message
             */
            function updateTimer() {
                if(timerProperties && timerProperties.stop == true){
                    if(timerProperties.stopCallback){
                        timerProperties.stopCallback();
                    }
                }
                else{
                    updateExpirationMessage();
                    if($scope.timer.currentTimeOut>0){
                        $scope.timer.currentTimeOut--;
                    }
                    else{
                        $scope.timer.currentTimeOut = OVERRIDE_TIME_PERIOD;
                        if($scope.alwaysOnConfiguration && $scope.alwaysOnConfiguration.overrideActive == true){
                            getCurrentCode(updateExpirationMessage);
                        }
                    }
                    updateTimerTimeout = $timeout(updateTimer,1000)
                }
            }


            /**
             * we would like the init function to be invoked only after all
             * digest and loading of the directive are done
             */
            $timeout(function () {
                init();
            },0,false);


            /**
             * initiate the qr code element
             */
            function initQrElement() {
                if($scope.alwaysOnConfiguration && $scope.alwaysOnConfiguration.overrideActive && !$scope.errorMessage.showError){
                    var qrImageEl = document.getElementById('qrImage');
                    if(qrImageEl){
                        qrImageEl.src = '/getAlwaysOnQrCode?accountId=' + $state.params.accountId;
                        qrImageEl.style.visibility = 'hidden';
                        qrImageEl.onerror = function () {
                            onImgError();
                        };
                        qrImageEl.onload = function () {
                            $timeout(function () {
                                $scope.showQRloader = false;
                                qrImageEl.style.visibility = 'visible';
                            }, 1);
                        };
                    }
                }
            }


            /**
             * function initiating the directive and all properties
             * inside the directive
             */
            function init() {

                startTimer();
                initQrElement();
                /**
                 * we wouldn't want to get each time for the account the always on configuration - for most accounts its
                 * not event relevant
                 */
                store.fetch({
                    path: "getAlwaysOnConfiguration?accountId="+$state.params.accountId,
                    method: "GET",
                    success: function(data) {
                        if(data!= null && data.status == "ERROR"){
                            data.notifications.forEach(function (notification) {
                                if(notification.field == "QR"){
                                    $scope.errorMessage.message = notification.message;
                                    $scope.errorMessage.showError = true;
                                }
                            })
                        }

                        if(data == null || !data.alwaysOnConfiguration) {
                            $scope.alwaysOnConfiguration = angular.copy($scope.model);
                        }
                        else{
                            delete $scope.errorMessage.message;
                            $scope.errorMessage.showError = false;
                            initQrElement();
                            $scope.origAlwaysOnConfiguration = angular.copy(data.alwaysOnConfiguration);
                            $scope.alwaysOnConfiguration = data.alwaysOnConfiguration;
                            if(data.code){
                                changeCode(data.code);
                                $scope.code.timestamp = (new Date).getTime();
                            }
                            updateExpirationMessage();
                        }
                    }
                });

                setPropertiesFunctions();
            }


            /**
             * setting functions on the always on properties for external invocation upon saving and
             * such
             */
            function setPropertiesFunctions() {
                if($scope.alwaysOnProperties && !$scope.alwaysOnProperties.setAlwaysOnConfig){
                    /**
                     * set method for always on configuration on the given account
                     * @param account
                     */
                    $scope.alwaysOnProperties.setAlwaysOnConfig = function (account) {
                        if(account)
                            account.alwaysOnConfiguration = $scope.alwaysOnConfiguration;
                    };
                }
                if($scope.alwaysOnProperties && !$scope.alwaysOnProperties.onSaveCallback){
                    /**
                     * callback invoked upon saving the account and the always on configuration as a part of it
                     */
                    $scope.alwaysOnProperties.onSaveCallback = function () {
                        $scope.alwaysOnProperties.wasChanged = false;
                        /**
                         * this mechanism will prevent us from having few updates
                         * of the timers
                         * @type {boolean}
                         */
                        timerProperties.stop = true;
                    }
                }
            }

            /**
             * change the code to the given value with proper padding
             * @param value
             */
            function changeCode(value) {
                while(value.toString().length<6){
                    value = '0'+ value;
                }
                $scope.code.value = value;
            }


            /**
             * setting a watch on changes on the always on configuration so that we could detact
             * any change and update the wasChanged property
             */
            $scope.$watch('alwaysOnConfiguration', function(newValue, oldValue) {
                if (newValue && !_.isEqual(newValue, oldValue)) {
                    $scope.alwaysOnProperties.wasChanged = !angular.equals($scope.origAlwaysOnConfiguration,$scope.alwaysOnConfiguration);
                    if(newValue.overrideActive === true){
                        if(!$scope.code.value){
                            getCurrentCode(updateExpirationMessage);
                        }
                        if(!$scope.errorMessage.showError){
                            $timeout(initQrElement,0,false);
                        }
                    }
                }
            }, true);

            $scope.$on('$destroy', function () {
                if (updateExpirationMessageTimeout) $timeout.cancel(updateExpirationMessageTimeout);
                if (updateTimerTimeout) $timeout.cancel(updateTimerTimeout);
                if (getCurrentCodeTimeout) $timeout.cancel(getCurrentCodeTimeout);
			});
        }]
    };
});
